/**
 * @generated SignedSource<<45a876ef3d8310fbc3b945e37e660e68>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FeedbackCardRequest$data = {
  readonly cancelledByCreator: boolean;
  readonly cancelledByUser: boolean;
  readonly feedback: {
    readonly " $fragmentSpreads": FragmentRefs<"FeedbackCardFeedback">;
  };
  readonly feedbackRecord: {
    readonly id: string;
  } | null;
  readonly hasDraftResponse: boolean;
  readonly id: string;
  readonly isArchived: boolean;
  readonly lastSeenByUser: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"FeedbackSubjectRequest_item">;
  readonly " $fragmentType": "FeedbackCardRequest";
};
export type FeedbackCardRequest$key = {
  readonly " $data"?: FeedbackCardRequest$data;
  readonly " $fragmentSpreads": FragmentRefs<"FeedbackCardRequest">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FeedbackCardRequest",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FeedbackSubjectRequest_item"
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasDraftResponse",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isArchived",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cancelledByUser",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cancelledByCreator",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastSeenByUser",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FeedbackRecordNode",
      "kind": "LinkedField",
      "name": "feedbackRecord",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FeedbackNode",
      "kind": "LinkedField",
      "name": "feedback",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "FeedbackCardFeedback"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "FeedbackRequestNode",
  "abstractKey": null
};
})();

(node as any).hash = "527b4014564bc91dd16b6615ec0b6310";

export default node;
